export default __webpack_public_path__ + "static/media/webmirror.26b2c0e2.png";